var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{staticClass:"grey",attrs:{"column":""}},[_c('span',[_vm._v("\"Hello1\"")])]),_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("\"Hello\"")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }